import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const ToastComponent = React.lazy(() => import("../Components/RootComponents/ToastComponent"));
const ToastPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <ToastComponent />
      </Suspense>
    </Fragment>
  );
};

export default ToastPage;
